import AgenticAIEmptySearch from '@/assets/AgenticAIEmtpySearch'
import TypingSearchViewAI from '../TypingSearchViewAI'

const AgenticSearchBarAI = ({
  searchTerm,
  type,
}: {
  searchTerm: string
  type: 'templates' | 'inspirations'
}) => {
  return searchTerm ? (
    <TypingSearchViewAI searchTerm={searchTerm} type={type} />
  ) : (
    <div className="flex flex-col h-full lg:flex-row gap-2.5 w-full pb-5 flex-1 items-center justify-center">
      <AgenticAIEmptySearch />
    </div>
  )
}

export default AgenticSearchBarAI
